export const GET_MAIN_LABS = "get_main_labs";
export const GET_MAIN_LABS_SUCCESS = "get_main_labs_success";
export const GET_MAIN_LABS_FAIL = "get_main_labs_fail";

export const ADD_LAB_INFORMATION = "add_lab_information";
export const ADD_LAB_INFORMATION_SUCCESSFUL = "add_lab_information_successfull";
export const ADD_LAB_INFORMATION_FAILED = "add_lab_information_failed";


// Territories
export const GET_TERRITORIES_LIST =
  "GET_TERRITORIES_LIST";
export const GET_TERRITORIES_LIST_SUCCESS =
  "GET_TERRITORIES_LIST_SUCCESS";
export const GET_TERRITORIES_LIST_FAIL =
  "GET_TERRITORIES_LIST_FAIL";
